import { NgModule } from "@angular/core";
import { CustomerRequestsModule } from "../features/customer-requests/customer-requests.module";
import { EventOrderSharedModule } from "../features/event-order/shared/event-order-shared.module";
import { ReferralRewardsModule } from "../features/referral-rewards/referral-rewards.module";
import { SharedModule } from "../shared/shared.module";
import { NewFeatureCarouselTriggerComponent } from "./new-feature-carousel-trigger/new-feature-carousel-trigger.component";
import { NewFeatureCarouselComponent } from "./new-feature-carousel/new-feature-carousel.component";
import { ProtectedHeaderComponent } from "./protected-header/protected-header.component";
import { ProtectedRoutingModule } from "./protected-routing.module";
import { ShadowWidgetUrlPopupComponent } from "./shadow-widget-url-popup/shadow-widget-url-popup.component";
import { ShadowWidgetComponent } from "./shadow-widget/shadow-widget.component";
import { UserIconMenuComponent } from "./user-icon-menu/user-icon-menu.component";
import { VenueRequestComponent } from "./venue-request/venue-request.component";

@NgModule({
  declarations: [
    ProtectedHeaderComponent,
    UserIconMenuComponent,
    VenueRequestComponent,
    ShadowWidgetComponent,
    ShadowWidgetUrlPopupComponent,
    NewFeatureCarouselComponent,
    NewFeatureCarouselTriggerComponent,
  ],
  imports: [SharedModule, ProtectedRoutingModule, CustomerRequestsModule, EventOrderSharedModule, ReferralRewardsModule],
  exports: [ProtectedHeaderComponent],
})
export class ProtectedModule {}
